import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import {AgentType, ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Track a user-typed message sent to an LLM chat
 *
 * This applies for new chats and existing chats.
 */
export function trackMessageSent({
  chatSessionId,
  chatType,
  agentType,
  messageCount,
  fileCount,
  includePublicData,
}: {
  chatSessionId: string;
  chatType: ChatType;
  agentType: AgentType;
  /** Number of existing messages in the chat */
  messageCount: number;
  /** Number of file uploads in the new message */
  fileCount: number;
  /** Whether the new message allows for public data. Null if N/A for the chat type. */
  includePublicData: boolean | null;
}): void {
  trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.SENT_LLM_CHAT_MESSAGE, {
    chatSessionId,
    chatType,
    agentType,
    messageCount,
    hasFileUploads: fileCount > 0,
    fileCount,
    includePublicData,
  });
}
